import React from 'react';
import { Container, Typography, Accordion, AccordionSummary, AccordionDetails } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Footer } from '../components/Footer';

export const FAQPage: React.FC = () => {
    const faqs = [
        {
            question: 'Where is Bielenda from?',
            answer: 'Bielenda is a modern Polish brand that has been producing high-quality natural face and body care cosmetics for over 30 years. Since its inception, Bielenda has been committed to the belief that products based on natural active ingredients provide the most comprehensive, safe, and skin-friendly care. Lavisha brings Bielenda Supremelab to Malaysia as part of our premium skincare offerings.'
        },
        {
            question: 'What is Bielenda Supremelab?',
            answer: 'Supremelab is a professional home care line created by Bielenda Professional in 2017. Bielenda Professional has been a leader in the professional cosmetics market since 2004, with treatments available in beauty salons, aesthetic medicine clinics, spas, and beauty schools. Supremelab brings that same expertise home—advanced formulas inspired by professional cosmetology, with effective active ingredients in optimal concentrations, designed to solve specific skin concerns.'
        },
        {
            question: 'Is Bielenda skincare suitable for my skin type?',
            answer: 'Bielenda Supremelab products are formulated for a wide range of skin types. Our lines target specific concerns: Hydra Glow for dehydrated, dull, or tired skin; Energy Boost for tired skin, discolouration, and signs of ageing; Pro Age Expert for mature skin and first wrinkles; Hyalu Minerals for dehydrated, combination, or weakened skin. The formulas are designed to be comfortable and safe, with appropriate penetration promoters for effective results. If you have very sensitive skin or known allergies, review the ingredient list and do a patch test before full use.'
        },
        {
            question: 'Do I need to use the full set of products?',
            answer: 'No. While using a complete routine can enhance results, you can choose products based on your specific skincare needs. Each Supremelab line is aimed at solving particular skin problems—pick Hydra Glow for hydration and radiance, Energy Boost for brightening, Pro Age Expert for anti-ageing, or Hyalu Minerals for deep hydration. For a tailored regimen, we recommend consulting with our business associates.'
        },
        {
            question: 'Which product should I choose for my concern?',
            answer: 'Hydra Glow is ideal for hydration, soothing, and a fresh, radiant complexion. Energy Boost targets dullness, discolouration, and signs of ageing with vitamin C and antioxidants. Pro Age Expert supports mature skin, firmness, and elasticity while smoothing initial wrinkles. Hyalu Minerals delivers deep hydration with multi-weight hyaluronic acid—great for dehydrated, combination, or tired skin. You can combine lines (e.g. Energy Boost with Hydra Glow) for multi-directional care.'
        },
        {
            question: 'Who should I contact for personalised advice or to purchase?',
            answer: 'Contact our business associates through this site for personalised advice or to purchase Bielenda Supremelab products.'
        }
    ];

    return (
        <>
            <Container maxWidth={false} sx={{ paddingTop: '100px', paddingBottom: '50px', backgroundColor: '#fff' }}>
                <Typography
                    variant="h4"
                    sx={{
                        fontFamily: 'ClaireMurphy',
                        fontSize: {
                            xs: '30px',
                            sm: '40px',
                            md: '50px',
                        },
                        fontWeight: 400,
                        textAlign: 'center',
                        color: 'rgba(61, 61, 61, 1)',
                        marginBottom: '30px',
                    }}
                >
                    Frequently Asked Questions
                </Typography>
                {faqs.map((faq, index) => (
                    <Accordion key={index} sx={{
                        borderRadius: '20px',
                        boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
                        marginBottom: '20px',
                        '&:before': {
                            display: 'none',
                        },
                        '&.Mui-expanded': {
                            margin: 'auto',
                        },
                    }}>
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon sx={{ color: 'rgba(0, 48, 135, 1)' }} />}
                            sx={{
                                backgroundColor: 'rgba(240, 248, 255, 1)',
                                borderRadius: '20px',
                                '& .MuiAccordionSummary-content': {
                                    margin: '20px',
                                },
                            }}
                        >
                            <Typography
                                sx={{
                                    fontFamily: 'Quicksand, sans-serif',
                                    fontSize: '20px',
                                    fontWeight: 600,
                                    color: 'rgba(61, 61, 61, 1)',
                                }}
                            >
                                {faq.question}
                            </Typography>
                        </AccordionSummary>
                        <AccordionDetails sx={{
                            padding: '20px',
                            backgroundColor: '#fff',
                            borderRadius: '20px',
                            marginBottom: '10px', // Add margin at the bottom
                            marginTop: '10px', // Add margin at the top
                        }}>
                            <Typography
                                sx={{
                                    fontFamily: 'Quicksand, sans-serif',
                                    fontSize: '16px',
                                    fontWeight: 400,
                                    lineHeight: '26.1px',
                                    color: 'rgba(61, 61, 61, 1)',
                                }}
                            >
                                {faq.answer}
                            </Typography>
                        </AccordionDetails>
                    </Accordion>
                ))}
            </Container>
            <Footer />
        </>

    );
};

export default FAQPage;
